export default "__VITE_ASSET__743ec105__"